var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"id":_vm.namePage,"fluid":""}},[_c('PageTitle',{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"subtitleStrong":_vm.subtitleStrong}}),_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }